module.exports = __webpack_public_path__ + "static/media/logo.63383b6c.png";